<template>
    <div>
        <div @click="dialogVisible=true"><slot></slot></div>
        <el-dialog v-if="userinfo"
                title="充值下载额度" class="fotoo"
                :visible.sync="dialogVisible"
                   @open="queryUserInfo"
                width="375px" append-to-body
                :before-close="handleClose">
            <div class="solid-top flex flex-direction align-center padding-xl">
                <el-descriptions title="" :column="2" size="mini" border class="margin-bottom">
                    <el-descriptions-item label="ID" span="2">{{userinfo.id}}</el-descriptions-item>
                    <el-descriptions-item label="用户名">{{userinfo.userName}}</el-descriptions-item>
                    <el-descriptions-item label="剩余下载额度">{{MG(userinfo.residualDownloadTraffic/1)}}</el-descriptions-item>
                    <template v-if="userbase.vipType==1">
                        <el-descriptions-item label="是否会员">
                            <el-tag size="small">{{userbase.vipType==1?'是':'否'}}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="会员时间">{{unixtoTime(userbase.startTime,'YYYY-MM-DD HH:II:SS')}} 至 {{unixtoTime(userbase.endTime,'YYYY-MM-DD HH:II:SS')}}</el-descriptions-item>
                    </template>
                </el-descriptions>
                <el-form ref="form" :model="form" :rules="rules"
                         label-width="100px">
                    <el-form-item label="下载额度" prop="traffic">
                        <el-input v-model.number="form.traffic" placeholder="请输入">
                            <template slot="append">M</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="额度类型" prop="getType">
                        <el-select v-model="form.getType" placeholder="请选择">
                            <el-option label="代用户购买（不回收）" value="1"></el-option>
                            <el-option label="赠送的（可回收）" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="form.getType==2">
                        <el-form-item label="赠送类型" prop="presentType">
                            <el-select v-model="form.presentType" placeholder="请选择">
                                <el-option label="充值会员赠送" value="1"></el-option>
                                <el-option label="推广赠送" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="过期时间" prop="datetime">
                            <el-date-picker
                                    v-model="form.datetime"
                                    type="datetime"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </template>
                    <el-form-item>
                        <div class="text-sm text-red" v-if="form.presentType==1">“充值会员赠送”必须与会员过期时间一模一样，否则无法回收</div>
                        <el-button type="primary" @click="onSubmit">提 交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
  import App from '../../../util/comfun'
  import QRCode from 'qrcodejs2'
  export default {
    props:{
        userId:String,
    },
    data () {
      return {
        MG:App.MG,
        unixtoTime:App.unixtoTime,
        userinfo:{},
        userbase:{},
        form:{
          datetime:new Date(new Date()/1+86400*30000),
        },
        dialogVisible:false,
        rules: {
          traffic: [
            {required: true, message: '请输入下载额度', trigger: 'blur'},
            {type: 'number', message: '下载额度必须是数字', trigger: 'blur'}
          ],
          getType: [
            {required: true, message: '请选择额度类型', trigger: 'blur'},
          ],
        }
      }
    },
    methods:{
      handleClick(){},
      handleClose(done) {
        this.$refs.form.resetFields()
        this.$emit('event',{act:'close'});
        done();
      },
      gotoHome(){
        this.$router.back()
      },
      show(uid){
        this.userId=uid
        this.queryUserInfo()
        this.dialogVisible=true
      },
      queryUserInfo(){
        this.queryUserList()
        let userRes=App.demand('/user/info','GET',{
          userId:this.userId,
        }).then(res=>{
          this.userinfo=res.data
        })
      },
      queryUserList(){
        let userRes=App.demand('/admin/user/queryUserList','POST',{
          userId:this.userId,
          pageIndex:1,
          pageSize:1,
        }).then(res=>{
          this.userbase=res.data.userList[0]
          if(this.userbase.vipType==1 && this.userbase.endTime){
            this.form.datetime=new Date(this.userbase.endTime*1000)
          }
        })
      },
      onSubmit(){
        if(this.form.getType==2){
          this.rules.presentType=[
            {required: true, message: '请选择赠送类型', trigger: 'blur'},
          ]
          this.rules.datetime=[
            {required: true, message: '请填写过期时间', trigger: 'blur'},
            {type: 'date', message: '必须是时间格式', trigger: 'blur'}
          ]
        }else{
          this.rules.presentType=null
          this.rules.datetime=null
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading=this.$loading({text:'处理中...',target:'.el-drawer'})
            App.demand('/admin/user/trafficAddToUser','POST',{
              "expireTime": (this.form.datetime && this.form.getType==2)?App.unixtoTime(this.form.datetime/1000,'YYYY-MM-DD HH:II:SS'):null,
              "getType": this.form.getType,
              "presentType": this.form.presentType,
              "traffic": this.form.traffic*1024*1024,
              "userId": this.userinfo.id,
            }).then(res=>{
              this.loading.close()
              if(res.code!=200) {return this.$message(res.message)}
              this.$emit('event',{act:'success'});
              this.$refs.form.resetFields()
              this.dialogVisible=false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    },
    mounted(){
        //this.queryUserInfo()
    },

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/components/traffic/addDialog.vue